import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
export default (function (_ref) {
  var fields = _ref.fields,
      _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages;
  // Construct a mapping of field names to field ids
  var fieldIds = fields.reduce(function (fieldIds, field) {
    return Object.assign(fieldIds, _defineProperty({}, field.name || field.fieldId, field.fieldId));
  }, {});
  var transformed = messages // strip out any field messages that don't have at least one entry in the fieldNames array
  .filter(function (message) {
    return message.fieldNames && message.fieldNames.length;
  }) // generate and collect one fieldMessage object per entry in the fieldNames array
  .reduce(function (fieldMessages, _ref2) {
    var fieldNames = _ref2.fieldNames,
        message = _ref2.message,
        level = _ref2.level,
        systemError = _ref2.systemError,
        messagePlacement = _ref2.messagePlacement;
    return fieldMessages.concat(fieldNames.map(function (fieldName) {
      return {
        fieldId: fieldIds[fieldName],
        message: message,
        level: level,
        systemError: systemError,
        messagePlacement: messagePlacement
      };
    }));
  }, []);
  return transformed;
});